{
  "greeting": {
    "morning": "Good morning, {{name}}",
    "afternoon": "Good afternoon, {{name}}",
    "evening": "Good evening, {{name}}"
  },
  "quickActions": {
    "title": "What do you want to do?"
  },
  "setup": {
    "title": "Set up your company",
    "progress": "{{done}} of {{total}} steps done",
    "complete": "Ready",
    "steps": {
      "identity": {
        "title": "Company identity and legal identifiers",
        "text": "Legal name, tax ID (matricule fiscal) and trade register number."
      },
      "regional": {
        "title": "Regional settings",
        "text": "Default language, time zone, date and number formats."
      },
      "units": {
        "title": "Units of measure",
        "text": "Piece, kilogram, metre... with their decimals."
      },
      "categories": {
        "title": "Product categories",
        "text": "A simple tree to organise the product catalog: Electrical > Lighting."
      },
      "team": {
        "title": "Your team",
        "text": "Create users, give them a role and their locations."
      },
      "locations": {
        "title": "Locations",
        "text": "Your warehouses and stores, with their zones and shelves."
      },
      "products": {
        "title": "Products",
        "text": "Add them one by one or import your catalog from Excel."
      }
    }
  },
  "activity": {
    "title": "Latest activity",
    "subtitle": "Every action is recorded and can never be changed.",
    "empty": "Nothing recorded yet."
  },
  "waiting": {
    "approvals_one": "{{count}} correction waits for your approval",
    "approvals_other": "{{count}} corrections wait for your approval",
    "approvalsText": "They are above the approval limit. Nothing has changed in stock yet.",
    "drafts_one": "You have {{count}} unfinished draft",
    "drafts_other": "You have {{count}} unfinished drafts",
    "draftsText": "Validate them or discard them so the stock stays right.",
    "toReceive_one": "{{count}} transfer to receive",
    "toReceive_other": "{{count}} transfers to receive",
    "toReceiveText": "On the way to your locations: confirm what arrived.",
    "toReceiveLate_one": "{{count}} of them is late.",
    "toReceiveLate_other": "{{count}} of them are late.",
    "countsToReview_one": "{{count}} count to review",
    "countsToReview_other": "{{count}} counts to review",
    "countsToReviewText": "Check the differences, then validate to correct the stock.",
    "countsInProgress_one": "{{count}} count in progress",
    "countsInProgress_other": "{{count}} counts in progress",
    "countsInProgressText": "Their products are frozen until they are validated or cancelled."
  },
  "openReports": "Open reports",
  "kpi": {
    "title": "Your stock today",
    "updated": "Updated at {{time}} · click any card to see the list",
    "labels": {
      "value": "Total stock value",
      "products": "Active products",
      "low": "Low stock",
      "out": "Out of stock",
      "negative": "Negative stock",
      "transit": "Transfers in transit",
      "today": "Movements today",
      "dead": "Dead stock"
    },
    "badges": {
      "low": "Low",
      "out": "Out",
      "negative": "Negative"
    },
    "items_one": "item",
    "items_other": "items",
    "productsUnit_one": "product",
    "productsUnit_other": "products",
    "transfersUnit_one": "transfer",
    "transfersUnit_other": "transfers",
    "operationsUnit_one": "operation",
    "operationsUnit_other": "operations",
    "valueNote": "All locations, at weighted average cost",
    "valueNoteSite": "This location, at weighted average cost",
    "addedThisMonth_one": "{{count}} added this month",
    "addedThisMonth_other": "{{count}} added this month",
    "lowNote": "At or below their minimum",
    "outNote": "Nothing left in any location",
    "negativeNote": "Needs a count or a correction",
    "transitNone": "Nothing on the way",
    "transitToday": "The oldest was sent today",
    "transitOldest_one": "The oldest was sent {{count}} day ago",
    "transitOldest_other": "The oldest was sent {{count}} days ago",
    "todayNote_one": "{{in}} in · {{out}} out · {{count}} adjustment",
    "todayNote_other": "{{in}} in · {{out}} out · {{count}} adjustments",
    "deadNote_one": "No movement for {{count}} day or more",
    "deadNote_other": "No movement for {{count}} days or more",
    "outNoteSite": "Nothing left in this location"
  },
  "attention": {
    "title": "Needs your attention",
    "seeAll": "See all alerts",
    "empty": "Nothing needs your attention",
    "emptyText": "No open alert right now."
  },
  "value": {
    "title": "Where is my stock value?",
    "bySite": "By location",
    "byCategory": "By category",
    "total": "TND in total",
    "noCategory": "No category",
    "empty": "No stock yet.",
    "note": "Values use the weighted average cost of each product. Users without the \"see costs\" permission see quantities only."
  },
  "inOut": {
    "title": "Stock in vs stock out",
    "unitValue": "Last 14 days · value in TND",
    "unitLines": "Last 14 days · movement lines",
    "in": "In",
    "out": "Out",
    "day": "Day",
    "table": "See the figures as a table",
    "empty": "No stock came in or went out in the last 14 days."
  },
  "sales": {
    "title": "Sales today",
    "open": "Sales reports",
    "labels": {
      "today": "Sold today (net)",
      "waiting": "Orders to hand over",
      "courier": "Courier cash still out"
    },
    "orders_one": "{{count}} sale",
    "orders_other": "{{count}} sales",
    "returns": "{{amount}} TND back",
    "vsYesterday": "{{value}} % vs yesterday",
    "ordersUnit_one": "order",
    "ordersUnit_other": "orders",
    "waitingNone": "Nothing waiting to leave",
    "oldest_one": "Oldest {{count}} day",
    "oldest_other": "Oldest {{count}} days",
    "courierNone": "Every delivery is settled",
    "deliveries_one": "{{count}} delivery not settled",
    "deliveries_other": "{{count}} deliveries not settled",
    "late_one": "{{count}} late",
    "late_other": "{{count}} late"
  }
}
